<template>
  <router-view />
</template>

<script>
export default {
  name: "AnalysisSingle"
};
</script>